import {
  faFacebookF,
  faInstagram,
  faXTwitter,
  faLinkedinIn,
  faPinterestP,
} from "@fortawesome/free-brands-svg-icons";

// Central place for business contact info + social links
export const CONTACT = {
  phone: "253-523-0098",
  phoneHref: "tel:2535230098",
  email: "Info@harmonyrisehomecare.com",
  emailHref: "mailto:Info@harmonyrisehomecare.com",
  address: "11413 172nd St Ct E, Puyallup, WA 98374",
  addressMap:
    "https://www.google.com/maps/search/?api=1&query=11413+172nd+St+Ct+E+Puyallup+WA+98374",
  hours: "6:00 AM – 10:30 PM",
};

export const SOCIALS = [
  {
    name: "Facebook",
    icon: faFacebookF,
    href: "https://www.facebook.com/profile.php?id=61573056625095",
  },
  {
    name: "Instagram",
    icon: faInstagram,
    href: "https://www.instagram.com/harmonyrisehomecare/",
  },
  {
    name: "X",
    icon: faXTwitter,
    href: "https://x.com/harmonyrisehome",
  },
  {
    name: "LinkedIn",
    icon: faLinkedinIn,
    href: "http://www.linkedin.com/in/harmony-rise-homecare-b57226350",
  },
  {
    name: "Pinterest",
    icon: faPinterestP,
    href: "https://in.pinterest.com/Harmony_rise_homecare/",
  },
];
